import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject, Subscription} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ConsentService {

  logoUrlSubject = new Subject<string>();
  headerTitleSubject = new Subject<string>();

  constructor() { }

  getLogoUrlSubject() {
    return this.logoUrlSubject;
  }

  getHeaderTitleSubscription() {
    return this.headerTitleSubject;
  }
}
